import { render } from "./TitleComponent.vue?vue&type=template&id=755ac2fe"
import script from "./TitleComponent.vue?vue&type=script&lang=js"
export * from "./TitleComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__